import React from "react";
import {FaChevronRight as ArrowSymbol} from "react-icons/fa";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {breakpointTablet} from "../../theme";
import {colorLightBlue} from "../../theme";

export const CustomerAccountOverview: React.FC<{ element: HTMLElement }> = (props) => {
  const {element} = props;
  const linkCustomerOrders = element.dataset.linkcustomerorders;
  const linkCustomerBacks = element.dataset.linkcustomercreditnotes;
  const linkCustomerRatings = element.dataset.linkcustomerratings;
  const linkCustomerData = element.dataset.linkcustomerdata;
  const linkCustomerAddress = element.dataset.linkcustomeraddress;
  const linkCustomerSubscriptions = element.dataset.linkcustomersubscriptions;
  const linkCustomerConnoxPlus = element.dataset.linkcustomerconnoxplus;
  const linkCustomerDelete = element.dataset.linkcustomerdelete;
  const linkCustomerLogOut = element.dataset.linkcustomerlogout;

  const {t} = useTranslation("customerAccount");

  return (
    <React.Fragment>
      <AccountSection>
        <AccountSectionHeader>{t("Ihre Bestellungen")}</AccountSectionHeader>
        <AccountSectionLink href={linkCustomerOrders}>
          <div>{t("Ihre Bestellungen")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
        <AccountSectionLink href={linkCustomerBacks}>
          <div>{t("Ihre Rücksendungen / Stornierungen")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
        <AccountSectionLink href={linkCustomerRatings}>
          <div>{t("Ihre Artikelbewertungen")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
      </AccountSection>
      <AccountSection>
        <AccountSectionHeader>{t("Ihre Daten & Abonnements")}</AccountSectionHeader>
        <AccountSectionLink href={linkCustomerData}>
          <div>{t("Ihre persönlichen Daten")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
        <AccountSectionLink href={linkCustomerAddress}>
          <div>{t("Ihre Rechnungs- und Lieferadressen")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
        <AccountSectionLink href={linkCustomerSubscriptions}>
          <div>{t("Newsletter-Optionen")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
      </AccountSection>
      <AccountSection>
        <AccountSectionHeader>{t("Ihr Konto")}</AccountSectionHeader>
        <AccountSectionLink href={linkCustomerConnoxPlus}>
          <div>{t("Ihre ConnoxPlus-Mitgliedschaft")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
        <AccountSectionLink href={linkCustomerDelete}>
          <div>{t("Kontolöschung beantragen")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
        <AccountSectionLink href={linkCustomerLogOut}>
          <div>{t("Ausloggen/Abmelden")}</div>
          <Arrow>
            <ArrowSymbol/>
          </Arrow>
        </AccountSectionLink>
      </AccountSection>
    </React.Fragment>
  );
};

const AccountSection = styled.div`
  margin-bottom: 3rem;
  padding: 0 20%;
  @media (max-width: ${breakpointTablet}px) {
    padding: 0;
  }
`;

const AccountSectionHeader = styled.h2`
  font-size: 1.25em;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 1rem;
`;

const AccountSectionLink = styled.a`
  border-bottom: 1px solid lightgrey;
  color: black;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  text-decoration: none;
  &:visited,
  &:link,
  &:active,
  &:hover {
    text-decoration: none;
  }
  &:first-of-type {
    border-top: 1px solid lightgrey;
  }
`;

const Arrow = styled.div`
  color: ${colorLightBlue};
`;
